import React, {Component} from 'react';
import {Link} from 'react-router-dom';
import {Grid} from 'react-bootstrap';
import {connect} from 'react-redux';
import ReactModal from 'react-modal';

import Information from '../information';
import {Actions} from 'components/actions';
import {ButtonDefault, LinkDefault} from 'components/buttons';
import {Modal, CloseModal, ModalContent} from 'components/modal';
import {Wrapper} from 'system/wrapper';
import {Divider} from 'components/common';
import List from '../list';

import {loadUser} from 'redux/actions/auth';

import close from 'images/general/close.svg';
import doctor from 'images/general/doctor.svg';
import hospital from 'images/general/hospital.svg';
import poslugi from 'images/general/poslugi.svg';
import guest from 'images/general/guest.svg';
import news from 'images/general/news.svg';

const mapStateToProps = state => ({
  token: state.auth.get('token')
});

const mapDispatchToProps = dispatch => ({
  onLoad: () => dispatch(loadUser())
})

class MainContent extends Component {

  constructor(props) {
    super(props);

    this.state = {
      modalOpen: false,
    }
    this.onToggleModal = this.onToggleModal.bind(this);

  }

  onToggleModal() {
    this.setState({modalOpen: !this.state.modalOpen})
  }

  componentDidMount() {
    if (this.props.token) {
      this.props.onLoad();
    }
  }

  render() {
    return (
    <div>
      <Information/>
      <Wrapper>
        <Grid>
          <List main>
            <li>
              <Link to="/institutions">
                <div>
                  <img src={hospital} alt="Лікарі"/>
                </div>
                <h3>Установи</h3>
              </Link>
            </li>
            <li>
              <Link to="/services">
                <div>
                  <img src={poslugi} alt="Лікарі"/>
                </div>
                <h3>Послуги</h3>
              </Link>
            </li>
            <li>
              <Link to="/habitants">
                <div>
                  <img src={guest} alt="Лікарі"/>
                </div>
                <h3>Мешканцям міста</h3>
              </Link>
            </li>
            <li>
              <Link to="/medical-staff">
                <div>
                  <img src={news} alt="Лікарі"/>
                </div>
                <h3>Медичним працівникам</h3>
              </Link>
            </li>
            <li>

              <Link to="/records">
                <div>
                  <img src={doctor} alt="Лікарі"/>
                </div>
                <h3>Запис до лікаря</h3>
              </Link>
            </li>
          </List>
          <Divider>
            {this.props.token ? (
              <Actions>
                <li>
                  <LinkDefault to="/reviews/accost">Звернення</LinkDefault>
                </li>
                <li>
                  <LinkDefault to="/reviews/gratitude">Подяка</LinkDefault>
                </li>
                <li>
                  <LinkDefault to="/reviews/complaint">Скарга</LinkDefault>
                </li>
              </Actions>
            ):(
              <Actions>
                <li>
                  <ButtonDefault value="Звернення" onClick={this.onToggleModal} />
                </li>
                <li>
                  <ButtonDefault value="Подяка" onClick={this.onToggleModal} />
                </li>
                <li>
                  <ButtonDefault value="Скарга" onClick={this.onToggleModal} />
                </li>
              </Actions>
            )}

          </Divider>
        </Grid>
      </Wrapper>
      <ReactModal isOpen={this.state.modalOpen} onRequestClose={() => {
        this.onToggleModal()
      }}
        className={{
          base: 'modalContent',
          afterOpen: 'myClass_after-open',
          beforeClose: 'myClass_before-close'
        }} contentLabel="Підтвердження запису"
        overlayClassName={{
          base: 'modalOverlay',
          afterOpen: 'myOverlayClass_after-open',
          beforeClose: 'myOverlayClass_before-close'
        }}>

        <Modal>
          <CloseModal>
            <div onClick={(event) => {
              this.onToggleModal()
            }}>
               <img src={close} alt="закрити" />
            </div>
          </CloseModal>
            <ModalContent>
              <h3>Для того, щоб залишити подяку, скаргу чи звернення потрібно бути користувачем системи</h3>
              <Divider>
                <h3>Якщо Ви зареєстрований користувач, <Link style={{color: "#edbd2f"}} to='/login'>увійдіть</Link> на портал</h3>
                <h3>Зареєструватися можна за цим <Link style={{color: "#edbd2f"}} to='/registration'>посиланням</Link></h3>
              </Divider>
            </ModalContent>

        </Modal>

      </ReactModal>
    </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MainContent);



// WEBPACK FOOTER //
// ./src/system/main/index.js